module.exports = __webpack_public_path__ + "img/tree-deciduous.262881ae.svg";